export default function PreviewModal({ activePreviewPage, onClose }) {
  if (!activePreviewPage) return null;

  return (
    <div 
      className="modal fade show d-block" 
      tabIndex="-1" 
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.65)' }}
      onClick={onClose}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content border-0 shadow">
          <div className="modal-header bg-dark text-white py-2">
            <h6 className="modal-title fw-bold text-truncate m-0" style={{ maxWidth: '80%' }}>
              <i className="bi bi-file-pdf me-2 text-danger"></i>
              Reading: {activePreviewPage.originFile} (Page {activePreviewPage.pageNumber})
            </h6>
            <button 
              type="button" 
              className="btn-close btn-close-white" 
              onClick={onClose}
            />
          </div>
          <div className="modal-body bg-secondary text-center p-3" style={{ minHeight: '450px' }}>
            <img 
              src={activePreviewPage.fullResSrc} 
              alt="Full resolution canvas content reader" 
              className="img-fluid rounded border bg-white shadow-sm mx-auto"
              style={{ maxHeight: '75vh', objectFit: 'contain' }}
            />
          </div>
          <div className="modal-footer bg-light py-2">
            <button
              type="button" 
              className="btn btn-sm btn-outline-secondary px-3" 
              onClick={onClose}
            >
              Close Reader
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
